
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Lip_and_oral_cavity_neoplasm',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Lip_and_oral_cavity_neoplasm.vue